import * as React from 'react';
import { connect } from 'react-redux';
import { getCarHire, getNextStep, getStepByName} from '../../../../actions/claimHistoryActionsV2'

export interface ClaimsProperties {
    isCarHire: boolean,
    profile: string,
    isSelected: boolean,
    done: boolean,
    nr: string,
    isActive: boolean,
    title: string,
    subtitle: string,
}

class ClaimsSteps extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.getNrImageSrc = this.getNrImageSrc.bind(this);
    }

    async handleClick(title: string) {
        if (title.toLowerCase() === "car hire") {
            this.props.handleGetCarHire()
        }
        else {
            this.props.handleGetStepByName(title);
        }
    }

     getNrImageSrc() {
        let src = "";
        if (this.props.isSelected) {
            src = "/my-policy/Images/Claims/Numbers/" + this.props.nr + "-red.png";
        }

        if (this.props.done) {
            src = "/my-policy/Images/icon-checkmark-nugreen-32px-32px.svg";
        }

        if (!this.props.isSelected && !this.props.done) {
            src = "/my-policy/Images/Claims/Numbers/" + this.props.nr + "-grey.png";
        }

        if (this.props.isCarHire && !this.props.isActive) {
            src = "/my-policy/Images/Claims/car-hire-inactive.png";
        }
        else if (this.props.isCarHire && this.props.isActive) {
            src = "/my-policy/Images/Claims/car-hire-active.png";
        }
        return src;
    }

    render() {
        return (
            <div className={(!this.props.isCarHire) ? + (this.props.isSelected || this.props.done) ? "Rectangle-claims cursor-pointer " : " Rectangle-claims " : (this.props.isActive && this.props.isCarHire) ? " Rectangle-carHire-active " : " Rectangle-carHire "}
                id="NotificationSteps" onClick={() => this.handleClick(this.props.title)}>
                <div className="row noma align-items-center">
                    <div className={(!this.props.isSelected && !this.props.done) ? "number-icon-inactive" : "number-icon-active" }>
                        <img alt="" title="" src={this.getNrImageSrc()}></img>
                    </div>
                    <div className="col nopa ml-10px">
                        <p className={(this.props.isSelected || this.props.done) ? "claim-step-subtitle mb-0" : this.props.isCarHire ? "claim-step-subtitle mb-0 text-disabled-carhire" : "claim-step-subtitle mb-0 text-disabled"} >{this.props.title}</p>
                        <p className={(this.props.isSelected || this.props.done) ? 'notifying-span mb-0px' : 'd-none'}>{this.props.subtitle}</p> {/*<----when completed, must be hidden/removed */}
                    </div>
                    <div className={!this.props.isSelected && !this.props.done ? "card-arrow-inactive" : "card-arrow-active"}>
                        <img className="float-right" src={(this.props.isSelected) ? '/my-policy/Images/Claims/dropdown-red.png'
                            : (this.props.isActive && this.props.isCarHire) ? "/my-policy/Images/Claims/Dropdown-arrow-right-white.png" : "/my-policy/Images/Claims/Dropdown.png"} />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        handleGetCarHire: () => dispatch(getCarHire()),
        handleGetStepByName: (name:string) => dispatch(getStepByName(name)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimsSteps);
